import {getComponentName} from './getComponentName';
import {COMPONENT_ID, ROOT_NODE} from '../../symbols';
import {SEISMIC_HOIST_TAG_NAME, APPEND_TO_META_PROP_NAME} from '../../constants';

export function createMetaData(host, actionMeta, hostVariables) {
	const componentName = getComponentName(host) || actionMeta.componentName;
	const id = hostVariables[COMPONENT_ID];
	const appendToMeta = actionMeta.retargeted ? actionMeta.appended : host[APPEND_TO_META_PROP_NAME];

	return {
		...actionMeta,
		...(appendToMeta !== undefined ? {appended: appendToMeta} : {}),
		hoistHost:
			hostVariables[ROOT_NODE].host.tagName === SEISMIC_HOIST_TAG_NAME
				? hostVariables[ROOT_NODE].host
				: undefined,
		componentName,
		id
	};
}
